/**
 * Regular Expressions for different uses
 */

// Find commas in string
export const commasRegex = /[,]+/

// Formating number
const formatNumberRegex = /(\d)(?=(\d{3})+(?!\d))/g

// For Ignoring accents
export const accentRegex = /[\u0300-\u036f]/g
export const NUMBER_LAST_POINT = /[^0-9.]|\.(?=.*\.)/g
export const NUMBER_LAST_COMMA = /[^0-9,]|,(?=,*,)/g
export const FILTER_PATTERN_CHECK = /[\u0300-\u036f]/g

export default formatNumberRegex
